import styled from 'styled-components';

export const FooterTable = styled.div`
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 100%;
  z-index: 10;
`;
export const MslJudgeModalSpan = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  color: #2e2e38;
`;

export const MSLHeadTable = styled.div`
  width: 100%;
  height: 60vh;
`;
